import React, {Component} from "react";
import {Container, Grid, Image} from "semantic-ui-react";
import MainImage from "../Images/What we did when we started.png";
import MobileMainImage from "../Images/MicrosoftTeams-image-(8)-375X550.png";
import MainHeader from "./MainHeader";
import Footer from "./Footer";
import Logo from "../Images/Logo_White.png";
import SearchImageWhite from "../Images/Group 8085.svg";
import "./Investors.css";
import HowItWorks from "../Images/newspapercuttinginvestors.png";
import ESG from "../Images/DSC_8093-editedinvestors.png";
import MobileHowItWorks from "../Images/newspapercutting-342x342.jpg";
import MobileESG from "../Images/olly-342x342.png";
import "./App.css";
import Arrow from "../Images/invisible box.svg";
import jQuery from "jquery";
import {Link} from "react-scroll";
import {Link as LinkThrough} from "react-router-dom";
import ScrollArrow from "../Images/Scroll down_W.svg";
import Download from "../Images/Download_Icon.png";
import LinkArrow from "../Images/LinkArrow.png";
import ResultsData from "./ResultsData"; 

export default class Investors extends Component {
    constructor(props) {
        super(props);
        this.state = {}

        this.updateWidgetHeight = this.updateWidgetHeight.bind(this);
    };

    updateWidgetHeight(event) {
        const frames = document.getElementsByTagName('iframe');
        for (let i = 0; i < frames.length; i++) {
            if (frames[i].contentWindow === event.source) {
                jQuery(frames[i]).height(event.data);
                break;
            }
        }
    }

    componentDidMount() {
        window.addEventListener('message', this.updateWidgetHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.updateWidgetHeight)
    }

    openInNewTab = (newWindow, url) => {
        newWindow.location = url;
    }

    fetchSignedUrl = async(newWindow, file) => {
        await Promise.resolve(fetch(`https://group.markselectrical.co.uk/document?name=${file}`)
            .then(response => response.json())
            .then((data) => {
                this.setState({docUrls: data} );
            })
            .catch(console.log))

        if(this.state.docUrls.length > 0){
            this.openInNewTab(newWindow, this.state.docUrls[0].url);
        }
        else{
            console.log("No url retrieved!")
        }
    }

    handleClick = (file) => {
        const newWindow = window.open();
        this.fetchSignedUrl(newWindow, file);
    }

    handleLinkClick = (url) => {
        const newWindow = window.open();
        this.openInNewTab(newWindow, url)
    }

    handleMouseEnter = (tag) => {
        this.setState({
            [tag.tag]: 7,
        });
    }

    handleMouseLeave = (tag) => {
        this.setState({
            [tag.tag]: 2,
        });
    }

    Button = (text, tag, link) => {
        return (
            <Container className='aboutUsButtonContainer2' onMouseEnter={() => this.handleMouseEnter({tag})} onMouseLeave={() => this.handleMouseLeave({tag})}>
                <LinkThrough className='aboutUsButton' to={link}><div className='homeButtonText'>{text}</div><div className='arrow' style={{ left: this.state[tag]}}><img alt='button arrow'  src={Arrow}/></div></LinkThrough>
            </Container>
        );
    }

    mainImage = () => {
        if(this.props.mobileSite === true) {
            return (
                <Image className='mainImage' src={MobileMainImage}/>
            )
        }
        else {
            return (
                <Image className='mainImage' src={MainImage}/>
            )
        }
    }

    mainCopy = () => {
        if(this.props.mobileSite === true) {
            return (
                <Container className='mobileInvestorsMainCopyContainer'>
                    <header className='mobileWorksSubCopy'>OPPORTUNITY</header>
                    <header className='mobileInvestorsMainCopy'>In 2006 we said 6% of MDA sales would come via the internet and this would grow to 20%</header>
                    <Container className='mobileInvestorsSubCopy'>
                        <header className='mobileSubCopy2'>Today, over 50% of sales come from this channel and it’s still growing</header>
                        {this.Button("INVESTMENT CASE", "case", "/investmentcase")}
                    </Container>
                </Container>
            )
        }
        else {
            return (
                <Container className='investorsMainCopyContainer'>
                    <header className='small_title_w'>OPPORTUNITY</header>
                    <header className='investorsMainCopy'>In 2006 we said 6% of MDA sales would come via the internet and this would grow to 20%</header>
                    <header className='investorsSubCopyText'>Today, over 50% of sales come from this channel and it’s still growing</header>
                    {this.Button("INVESTMENT CASE", "case", "/investmentcase")}
                    <Container className='investorsScrollArrow'>
                        <Link to="point1" spy={true} smooth={true}><Image className='scrollArrowImg' src={ScrollArrow}/></Link>
                    </Container>
                </Container>
            )
        }
    }

    greyRow = () => {
        if(this.props.mobileSite === true) {
            return (
                <Grid.Row className='investorsRows'>
                    <header className='investorsSharePriceHeader'>SHARE PRICE</header>
                    <Container className='mobileSharePriceWidgetContainer'>
                        <iframe title='share price widget' className="mobileSharePriceIFrame" src="https://irtools.co.uk/tools/share_price/2aae5d7d-6d97-444a-b91a-a3545943f1d8"/>
                    </Container>
                </Grid.Row>
            )
        }
        else {
            return (
                <Grid.Row className='investorsGreyRow'>
                    <Container className='investorsSharePrice'>
                        <header className='investorsSharePriceHeader'>SHARE PRICE</header>
                        <Container className='investorsSharePriceWidgetContainer1'>
                            <iframe title='share price widget' className="sharePriceIFrame" src="https://irtools.co.uk/tools/share_price/2aae5d7d-6d97-444a-b91a-a3545943f1d8"/>
                        </Container>
                    </Container>
                </Grid.Row>
            )
        }
    }

    imageRows = () => {
        if(this.props.mobileSite === true) {
            return (
                <Grid.Row>
                    <Grid.Column className='mobileInvestorsDataColumns'>
                        <img className='investorsImage' alt='old ME newspaper advert clipping' src={MobileHowItWorks}/>
                        <Container className='mobileInvestorsSubContainers'>
                            <header className='mobileInvestorsSubCopy3'>Customers first, second and third</header>
                            {this.Button("HOW IT WORKS", "how", "/howitworks")}
                        </Container>
                    </Grid.Column>
                    <Grid.Column className='mobileInvestorsDataColumns'>
                        <img className='investorsImage' alt='polystyrene recycling' src={MobileESG}/>
                        <Container className='mobileInvestorsSubContainers2'>
                            <header className='mobileInvestorsSubCopy3'>It just makes sense</header>
                            {this.Button("ESG", "esg", "/esg")}
                        </Container>
                    </Grid.Column>
                </Grid.Row>
            )
        }
        else {
            return (
                <Grid stackable className='investorsImagesGrid'>
                    <Grid.Row>
                        <Grid.Column className='investorsDataColumns'>
                            <img alt='old ME newspaper advert clipping' src={HowItWorks}/>
                            <Container className='investorsSubContainers'>
                                <header className='investorsSubCopy3'>Customers first, second and third</header>
                                {this.Button("HOW IT WORKS", "how", "/howitworks")}
                            </Container>
                        </Grid.Column>
                        <Grid.Column className='investorsDataColumns'>
                            <img alt='polystyrene recycling' src={ESG}/>
                            <Container className='investorsSubContainers'>
                                <header className='investorsSubCopy3'>It just makes sense</header>
                                {this.Button("ESG", "esg", "/esg")}
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            )
        }
    }

    mainParagraph = () => {
        if(this.props.mobileSite === true) {
            return (
                <Container className='resultsContainer2'>
                    <h2 className='mobileResultsHeader'>Results, reports &amp; presentations</h2>
                </Container>
            )
        }
        else {
            return (
                <Container style={{'padding-top':'5%'}}>
                    <h2 className='h2'>Results, reports &amp; presentations</h2>
                </Container>
            )
        }
    }


    dataGrids = () => {
        if(this.props.mobileSite === true) {
            return (
                <Grid.Row className='mobileInvestorsDataGrids'>
                    <Grid stackable className='investorsDataGrid'>
                        <Grid.Row>
                            <Container className='mobileInvestorsNewsTitle'>
                                <h2 className='mobileH2'>Latest news</h2>
                            </Container>
                        </Grid.Row>
                        <Grid.Row>
                            <Container className='investorsSharePriceWidgetContainer'>
                                <iframe title='rns widget' className="sharePriceIFrame2" src="https://irtools.co.uk/tools/news/9f5a6b3a-262c-4474-a2fb-f6c9489b81f1"/>
                            </Container>
                            <Container className='investorsSharePriceButtonCont1'>
                                <LinkThrough className='shareholderFinancialCalenderButton' to="/regulatorynews">REGULATORY NEWS<img alt='button icon' className='shareholderButtonArrow' src={Arrow}/></LinkThrough>
                            </Container>
                        </Grid.Row>
                    </Grid>
                    <Grid style={{'padding-left':'0', 'padding-right':'0', 'display':'none'}} divided='vertically' className='investorsDataGrid'>
                        <h2 className='mobileH2'>Financial calendar</h2>
                        <Grid.Row>
                            <Grid.Column className='mobileInvestorsDataColumns2'>
                                <header className='mobileInvestorsTableHeaders'>DATE</header>
                            </Grid.Column>
                            <Grid.Column className='mobileInvestorsDataColumns2'>
                                <header className='mobileInvestorsTableHeaders'>HEADLINE</header>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column className='mobileInvestorsDataColumns2'>
                                <header className='investorsTableDate'>21/07/2021</header>
                            </Grid.Column>
                            <Grid.Column className='mobileInvestorsDataColumns2'>
                                <header className='investorsTableTitle'>2020 report 1</header>
                                <header>DOWNLOAD PDF</header>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column className='mobileInvestorsDataColumns2'>
                                <header className='investorsTableDate'>21/07/2021</header>
                            </Grid.Column>
                            <Grid.Column className='mobileInvestorsDataColumns2'>
                                <header className='investorsTableTitle'>2020 report 1</header>
                                <header>DOWNLOAD PDF</header>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Grid.Row>
            )
        }
        else {
            return(
                <Grid.Row>
                    <Container className='esgContainer4'>
                        <Grid.Row>
                            <Container className='investorsNewsTitle'>
                                <h2 className='h2'>Latest news</h2>
                            </Container>
                        </Grid.Row>
                        <Grid.Row>
                            <Container className='investorsSharePriceWidgetContainer1'>
                                <iframe title='rns widget' className="sharePriceIFrame2" src="https://irtools.co.uk/tools/news/9f5a6b3a-262c-4474-a2fb-f6c9489b81f1"/>
                            </Container>
                            <Container className='investorsSharePriceButtonCont1'>
                                <LinkThrough className='shareholderFinancialCalenderButton' to="/regulatorynews">REGULATORY NEWS<img alt='button arrow' className='shareholderButtonArrow' src={Arrow}/></LinkThrough>
                            </Container>
                        </Grid.Row>
                    </Container>
                    <Container style={{'display':'none'}} className='esgContainer4'>
                        <h2 className='h2'>Financial calendar</h2>
                        <Grid stackable divided='vertically' className='shareDataGrid'>
                            <Grid.Row>
                                <Grid.Column className='investorsDataColumns4'>
                                    <header className='investorsCalendarHeadline'>DATE</header>
                                </Grid.Column>
                                <Grid.Column className='investorsDataColumns2'>
                                    <header className='investorsCalendarHeadline'>HEADLINE</header>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column className='investorsDataColumns4'>
                                    <header className='esgCalendarDate'>20 July 2021</header>
                                </Grid.Column>
                                <Grid.Column className='investorsDataColumns2'>
                                    <header className='esgCalendarBody'>Price monitoring extention</header>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column className='investorsDataColumns4'>
                                    <header className='esgCalendarDate'>20 July 2021</header>
                                </Grid.Column>
                                <Grid.Column className='investorsDataColumns2'>
                                    <header className='esgCalendarBody'>Price monitoring extention</header>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row/>
                        </Grid>
                    </Container>
                </Grid.Row>
            )
        }
    }

    render() {
        return (
            <div className='investors'>
                <Grid className='mainGrid'>
                    <Grid.Row className='investorsRows'>
                        <MainHeader mobileSite={this.props.mobileSite} logo={Logo} h3='h3' shopButton='shopButton'
                                    menuDropdown='whiteDropdown' searchImage={SearchImageWhite}
                                    sharePriceUrl='https://irtools.co.uk/tools/share_price/db9f7736-8152-4900-8987-5ca09eb494c4'
                                    navLinks='nav-links' hamburgerColour='white'/>
                        {this.mainImage()}
                        {this.mainCopy()}
                    </Grid.Row>
                    {this.greyRow()}
                    <Grid.Row className='investorsRows'>
                        {this.imageRows()}
                    </Grid.Row>
                    <Grid.Row>
                        <Container className='resultsContainer1'>
                            {this.mainParagraph()}
                            <ResultsData mobileSite={this.props.mobileSite} dataLimit={6}></ResultsData>
                        </Container>
                    </Grid.Row>
                 
                        {this.dataGrids()}
                    
                </Grid>
                <Footer mobileSite={this.props.mobileSite}/>
            </div>
        )
    }
}